export enum Player {
  PlayerA = 0,
  PlayerB = 1,
}
